import { Controller } from '@hotwired/stimulus'

// Switches CNIC / license / passport copy and whether the back upload is required.
export default class extends Controller {
  static targets = [
    'type',
    'numberLabel',
    'frontTitle',
    'frontSubtitle',
    'frontRequired',
    'frontInput',
    'backCard',
    'backTitle',
    'backSubtitle',
    'backRequired',
    'backInput'
  ]

  static values = {
    copy: Object
  }

  connect () {
    this.refresh()
  }

  refresh () {
    const key = this.hasTypeTarget ? this.typeTarget.value : 'cnic'
    const copy = this.copyValue[key] || this.copyValue.cnic
    if (!copy) return

    if (this.hasNumberLabelTarget) this.numberLabelTarget.textContent = copy.number_label
    if (this.hasFrontTitleTarget) this.frontTitleTarget.textContent = copy.front_title
    if (this.hasFrontSubtitleTarget) this.frontSubtitleTarget.textContent = copy.front_subtitle
    if (this.hasBackTitleTarget) this.backTitleTarget.textContent = copy.back_title
    if (this.hasBackSubtitleTarget) this.backSubtitleTarget.textContent = copy.back_subtitle

    const backRequired = !!copy.back_required
    if (this.hasBackCardTarget) {
      this.backCardTarget.classList.toggle('opacity-60', !backRequired)
    }
    if (this.hasBackRequiredTarget) {
      this.backRequiredTarget.textContent = backRequired ? 'Required' : 'Optional'
      this.backRequiredTarget.className = backRequired
        ? 'shrink-0 rounded-full bg-rose-50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-rose-600 ring-1 ring-rose-100'
        : 'shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-500'
    }
    if (this.hasBackInputTarget) this.backInputTarget.required = backRequired
    if (this.hasFrontInputTarget) this.frontInputTarget.required = true
    if (this.hasFrontRequiredTarget) this.frontRequiredTarget.textContent = 'Required'
  }
}
